import {Component, Input, OnInit} from '@angular/core';
import {CampaignForm} from '@app/@core/advertising/campaign/campaign-form';
import {CampaignDraft} from "@app/@core/advertising/campaign/campaign-draft";
import {ConfigService} from "@app/@core/@config/config.service";

@Component({
  selector: 'app-campaign-advertiser-name[campaignForm]',
  templateUrl: './campaign-advertiser-name.component.html',
  styleUrls: ['./campaign-advertiser-name.component.scss']
})
export class CampaignAdvertiserNameComponent {
  @Input() campaignForm!: CampaignForm;

  constructor() { }
}
